import departmentIcon from 'media/icons/department.svg';
import homeOutline from 'media/icons/home-outline.svg';
import settingsIcon from 'media/icons/settings.svg';

import { getUserRole } from './auth';

const adminTabs = [
  {
    key: 'departments',
    label: 'Departments',
    icon: departmentIcon,
    route: '/departments',
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: settingsIcon,
    route: '/settings',
  },
];

const superAdminTabs = [
  {
    key: 'home',
    label: 'Home',
    icon: homeOutline,
    route: '/',
  },
  {
    key: 'departments',
    label: 'Departments',
    icon: departmentIcon,
    route: '/departments',
  },
  {
    key: 'users',
    label: 'Users (Super Admin)',
    icon: departmentIcon,
    route: '/users',
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: settingsIcon,
    route: '/settings',
  },
];

const getSidebarTabs = () => {
  switch (getUserRole()) {
    case 'SUPER_ADMIN':
      return superAdminTabs;
    case 'ADMIN':
    default:
      return adminTabs;
  }
};

export default getSidebarTabs;
